import React from 'react'

import TabbedModal, { Tab, UserItem } from 'components/TabbedModal'
import { Avatar } from 'shared/ui'
import IsolateScroll from 'components/IsolateScroll'

import { getAgentUsername } from 'util/agents'

import styles from './styles.css'

const MentionModal = props => {
  const { isOpen, filteredAgents, agentMention } = props

  if (!isOpen || filteredAgents.length === 0) return <EmptyState {...props} />
  if (agentMention.word === '@') return <InitialState {...props} />

  return <NormalState {...props} />
}

const InitialState = ({
  bottomOffset,
  suggestedAgents,
  sortedAgents,
  doMentionAgent,
  close,
}) => (
  <TabbedModal
    className={styles.root}
    position="bottom"
    offset={{ bottom: bottomOffset }}
    onBackgroundClick={close}
  >
    <Tab name="suggested">
      <AgentList agents={suggestedAgents} doMentionAgent={doMentionAgent} />
    </Tab>
    <Tab name="a-z">
      <AgentList agents={sortedAgents} doMentionAgent={doMentionAgent} />
    </Tab>
  </TabbedModal>
)

const NormalState = ({
  bottomOffset,
  filteredAgents,
  doMentionAgent,
  close,
}) => (
  <TabbedModal
    className={styles.root}
    position="bottom"
    offset={{ bottom: bottomOffset }}
    onBackgroundClick={close}
  >
    <Tab name={`choose ${app.t('agent_with_article')}`}>
      <AgentList agents={filteredAgents} doMentionAgent={doMentionAgent} />
    </Tab>
  </TabbedModal>
)

const EmptyState = () => null

const AgentList = ({ agents, doMentionAgent }) => (
  <IsolateScroll className={styles.scrollableList}>
    {agents &&
      agents.length !== 0 &&
      agents.map(agent => (
        <UserItem
          title={getAgentUsername(agent)}
          hint={agent.name}
          leftSide={
            <Avatar size="32" actor={agent} className={styles.avatar} />
          }
          // eslint-disable-next-line react/jsx-no-bind
          onClick={() => doMentionAgent(agent.id, ' ')}
        />
      ))}
  </IsolateScroll>
)

export default MentionModal
